import ApplyAdjustmentForm from './ApplyAdjustmentForm';

export default ApplyAdjustmentForm;
